import {
  UPDATE_BENEFIT_GROUP_ITEM,
  UPDATE_BENEFIT_GROUP_ITEM_SUCCESS,
  UPDATE_BENEFIT_GROUP_ITEM_ERROR,
  UPDATE_BENEFIT_GROUP_ITEM_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateBenefitGroupItems = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BENEFIT_GROUP_ITEM:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_GROUP_ITEM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_GROUP_ITEM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case UPDATE_BENEFIT_GROUP_ITEM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateBenefitGroupItems;
